import { helpers, mui, ts } from '_core';

const decimalLabels = ['Factor Exposures'];

const conditionalFormatting = (field: string) => {
  if (decimalLabels.includes(field)) {
    return helpers.tabularFormatters.formatTo('float', {
      roundDigits: 2,
      commasOnThousands: true,
    });
  }

  return helpers.tabularFormatters.formatTo('float', {
    roundDigits: 2,
    commasOnThousands: true,
    suffix: '%',
    multiplier: 100,
  });
};

const customValueGetter: mui.dataGrid.GridColDef['valueGetter'] = (value, row) => {
  return conditionalFormatting(row?.label);
};

export const summaryColumns = [
  {
    key: 'label',
    name: '',
    formatter: helpers.tabularFormatters.formatTo('string', { align: 'left' }),
    filter: 'string',
  },
  {
    key: 'metric',
    name: 'Metric',
    formatter: helpers.tabularFormatters.formatTo('string', { align: 'left' }),
    filter: 'string',
  },
  {
    key: 'initial',
    name: 'Previous',
    formatter: helpers.tabularFormatters.formatTo('string', { align: 'right' }),
    filter: 'number',
    valueGetter: customValueGetter,
    renderCell: customValueGetter,
  },
  {
    key: 'optimal',
    name: 'Optimal',
    formatter: helpers.tabularFormatters.formatTo('string', { align: 'right' }),
    filter: 'number',
    valueGetter: customValueGetter,
    renderCell: customValueGetter,
  },
  {
    key: 'diff',
    name: 'Difference',
    formatter: helpers.tabularFormatters.formatTo('float', {
      align: 'right',
      roundDigits: 2,
      multiplier: 100,
      suffix: '%',
      commasOnThousands: true,
    }),
    filter: 'number',
  },
] as ts.types.components.dataGrid.ColumnsData;
